import React, { useEffect, useRef, useState } from "react";

import CustomTooltip from "../../common/styles/components/tooltip/CustomTooltip";

import "./WPAgGrid.scss";

const WPAGridCellRender = (props) => {
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
  const cellRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (cellRef.current) {
      setIsOverflowing(
        cellRef.current.scrollWidth > cellRef.current.clientWidth
      );
    }
  }, [cellValue]);

  return (
    <CustomTooltip text={isOverflowing ? cellValue : ""} placement="top">
      <div ref={cellRef} className="ag-tooltip-container">
        {cellValue}
      </div>
    </CustomTooltip>
  );
};

export default WPAGridCellRender;
